import { Component, ViewChild } from '@angular/core'
import { WaybillOrderServiceProvider } from '../../../providers/qdb/qdb-service'
import { LoadingController, Loading, ModalController, NavParams, NavController, ToastController } from 'ionic-angular';
import { ShipmentsDetailPage } from './shipments.modal';

@Component({
    templateUrl: 'shipments.html',
    providers: [WaybillOrderServiceProvider]
})

export class ShipmentsPage {
    items: any;
    searchQuery: string = '';
    loading: Loading;
    getParm: any;
    @ViewChild('search') search: any;
    constructor(private provider: WaybillOrderServiceProvider, private toastCtrl: ToastController, private loadingCtrl: LoadingController, private modalCtrl: ModalController, private navCtrl: NavController, public navParams: NavParams) {
        this.searchFocus();
        this.getParm = this.navParams.get('awbs_param');
        if (this.getParm == undefined) {
            return;
        }
        this.query();
    }
    query() {
        this.showLoading();
        let parm;
        if (this.getParm != undefined) {
            parm = { "awbs": this.getParm };
        }
        if (this.searchQuery != '') {
            let inputParm = this.searchQuery.split(",");
            let arr: any = [];
            inputParm.forEach(function (value) {
                arr.push(value);
            })
            parm = { "awbs": arr };
        }
        this.provider.search(parm).then(data => {
            let resData: any;
            resData = data;
            if (resData.data.content.length > 0) {
                this.items = resData.data.content;
            }
            else {
                this.toastCtrl.create({
                    message: "No results",
                    duration: 2000,
                    position: 'middle'
                }).present();
            }
            this.loadingDissmiss();
        }, (error) => {
            this.loadingDissmiss();
        });
    }

    loadingDissmiss() {
        if (this.loading != null && this.loading.isOverlay) {
            this.loading.dismiss();
        }
    }

    showLoading() {
        this.loading = this.loadingCtrl.create({
            content: "Please Wait..."
        });
        this.loading.present();
    }

    itemSelected(item) {
        let detailPage = this.modalCtrl.create(ShipmentsDetailPage, item);
        detailPage.present();
    }

    searchFocus(): void {
        setTimeout(() => {
            this.search.setFocus();
        }, 500);
    }

    cancel() {
        this.navCtrl.pop();
    }
}




// WEBPACK FOOTER //
// ./src/pages/backoffice/shipments/shipments.ts